import { __extends } from 'tslib';
import * as React from 'react';
import { UitkImage, UitkQueuedImage, UitkFigure } from 'uitk-react-images';
import { classNames } from 'uitk-react-utils';
import { isYoutubeSource, UitkVideo } from 'uitk-react-video';
import styles from './uitk-media-gallery.css';

var getClassNameList = classNames.bind(styles);
var UitkMediaGalleryImage = /** @class */ (function (_super) {
    __extends(UitkMediaGalleryImage, _super);
    function UitkMediaGalleryImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMediaGalleryImage.prototype.stopTransitionPropagation = function (e) {
        e.stopPropagation();
    };
    UitkMediaGalleryImage.prototype.render = function () {
        var _a = this.props, ariaHidden = _a.ariaHidden, className = _a.className, alt = _a.alt, src = _a.src, videoAnalytics = _a.videoAnalytics, stretchToFill = _a.stretchToFill, videoButtonText = _a.videoButtonText;
        var isSourceFromYoutube = isYoutubeSource(src);
        var cssClasses = getClassNameList(className, 'uitk-media-gallery-image', {
            'uitk-media-gallery-image-size-auto': !stretchToFill && !isSourceFromYoutube
        });
        var mediaGalleryImageScopedUitkFigureClass = getClassNameList('uitk-image_media-gallery-image');
        var mediaGalleryImageScopedUitkImageClass = getClassNameList('uitk-image-media_media-gallery-image');
        var renderedElement;
        if (className && className.includes('uitk-media-gallery-image-active')) {
            renderedElement = isSourceFromYoutube ? (React.createElement(UitkVideo, { alt: alt, analytics: videoAnalytics, isDialog: true, src: src, buttonText: videoButtonText })) : (React.createElement(UitkImage, { className: mediaGalleryImageScopedUitkImageClass, alt: alt, src: src, placeholderImage: stretchToFill }));
        }
        else {
            renderedElement = (React.createElement(UitkQueuedImage, { className: mediaGalleryImageScopedUitkImageClass, alt: alt, src: src, groupId: "media-gallery" }));
        }
        return (React.createElement("div", { className: cssClasses, "aria-hidden": ariaHidden, onTransitionEnd: this.stopTransitionPropagation },
            React.createElement(UitkFigure, { key: src, ratio: UitkFigure.AspectRatio.R16_9, className: mediaGalleryImageScopedUitkFigureClass }, renderedElement)));
    };
    UitkMediaGalleryImage.displayName = 'UitkMediaGalleryImage';
    return UitkMediaGalleryImage;
}(React.PureComponent));

export { UitkMediaGalleryImage };
